<template>
  <hm-content title="" :hidden="hidden">
    <div class="table-panel flex flex-end text-right">
      <el-input
        size="small"
        clearable
        class="mr10 ipt"
        v-model.trim="searchCondition.sendName"
        placeholder="请输入发券名称"
      ></el-input>
      <el-input
        size="small"
        clearable
        class="mr10 ipt"
        v-model.trim="searchCondition.ruleName"
        placeholder="请输入优惠券名称"
      ></el-input>
      <el-select
        v-model="searchCondition.timeType"
        size="small"
        style="width:101px;marginLeft:4px"
        class="time-type"
        filterable
      >
        <el-option label="使用时间" value="use"></el-option>
        <el-option label="发放时间" value="send"></el-option>
      </el-select>
      <el-date-picker
        v-model="searchCondition.date"
        type="datetimerange"
        align="right"
        start-placeholder="请选择时间段"
        end-placeholder="请选择时间段"
        value-format="yyyy-MM-dd HH:mm:ss"
        :default-time="['00:00:00', '23:59:59']"
        size="small "
        class="mr10 time"
      ></el-date-picker>

      <el-input
        size="small"
        clearable
        class="mr10 ipt"
        v-model.trim="searchCondition.memberMobile"
        placeholder="请输入会员手机"
      ></el-input>
      <el-select
        clearable
        v-model="searchCondition.useStatus"
        placeholder="请选择使用状态"
        size="small"
        class="mr10"
      >
        <el-option label="未使用" value="4"></el-option>
        <el-option label="已使用" value="2"></el-option>
        <el-option label="已领取" value="0"></el-option>
        <el-option label="已作废" value="5"></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="search">查询</el-button>
    </div>
    <div class="flex flex-start table-panel ">
      <el-button type="primary" size="small" @click="reports"
        >生成报表</el-button
      >
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
        height="600"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="couponCode"
          label="券码"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="sendName"
          label="发券名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="sendEvent"
          label="发券方式"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="ruleName"
          label="优惠券名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="couponMoney"
          label="优惠券面额"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="orderType"
          label="订单类型"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="toOrder"
          label="使用订单号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="fromOrder"
          label="来源订单号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="usedTime"
          label="使用时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shopName"
          label="使用门店"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="totPrice"
          label="订单金额"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberMobile"
          label="会员手机号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberName"
          label="会员姓名"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="sendTime"
          label="优惠券发放时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="useStatus"
          label="优惠券使用状态"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="verifyOperator"
          label="优惠券核销人"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="verifyTime"
          label="优惠券核销备注"
        >
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
          :page-size="pageSize"
        ></el-pagination>
      </div>
    </div>
  </hm-content>
</template>

<script>
import { setCookie, getCookie } from "@/utils/utils";
export default {
  components: {},
  data() {
    return {
      hidden: true,
      total: 0,
      currentPage: 1,
      pageSize: 10,
      list: [],
      searchCondition: {
        timeType: "use",
        date: []
      }
    };
  },
  computed: {},
  watch: {},
  created() {
    let nowDate = new Date();
    let date = {
      year: nowDate.getFullYear(),
      month: nowDate.getMonth() + 1,
      date: nowDate.getDate()
    };
    if (date.month >= 1 && date.month <= 9) {
      date.month = "0" + date.month;
    }
    if (date.date >= 0 && date.date <= 9) {
      date.date = "0" + date.date;
    }
    let systemDate = date.year + "-" + date.month + "-" + date.date;

    this.searchCondition.date = [
      `${systemDate} 00:00:00`,
      `${systemDate} 23:59:59`
    ];
    this.getParamsCookie();
  },
  mounted() {
    this.queryList();
  },

  methods: {
    setParamsCookie() {
      setCookie({
        key: "couponDetailsParams",
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({
        key: "couponDetailsParams",
        type: "session"
      });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async reports() {
      if (this.isArray(this.searchCondition.date)) {
        const searchCondition = JSON.parse(
          JSON.stringify(this.searchCondition)
        );
        searchCondition.queryStartTime =
          this.searchCondition.date && this.searchCondition.date.length > 0
            ? this.searchCondition.date[0]
            : "";
        searchCondition.queryEndTime =
          this.searchCondition.date && this.searchCondition.date.length > 0
            ? this.searchCondition.date[1]
            : "";

        const { code } = await this.$store.dispatch(
          "queryExportCouponDetails",
          searchCondition
        );
        if (code === "0") {
          this.hidden = false;
          this.$message({
            message: "已加入导出队列，请在导出列队中查看！",
            type: "success"
          });
        } else {
          this.$message({
            message: "请选择查询时间段！",
            type: "warning"
          });
        }
      }
    },
    async queryList() {
      if (this.isArray(this.searchCondition.date)) {
        let params = {
          pageNo: this.currentPage,
          pageSize: this.pageSize
        };
        const searchCondition = JSON.parse(
          JSON.stringify(this.searchCondition)
        );
        searchCondition.queryStartTime =
          this.searchCondition.date && this.searchCondition.date.length > 0
            ? this.searchCondition.date[0]
            : "";
        searchCondition.queryEndTime =
          this.searchCondition.date && this.searchCondition.date.length > 0
            ? this.searchCondition.date[1]
            : "";

        this.setParamsCookie();

        Object.assign(params, searchCondition);
        const { result } = await this.$store.dispatch(
          "queryDaystatCouponDetailsList",
          params
        );
        const { records, total } = result;
        this.list = records;
        this.total = total;
      } else {
        this.$message({
          message: "请选择查询时间段！",
          type: "warning"
        });
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
